import {
    apiRequest,
    masterWorkUnit,
    masterEmployeeStatus
} from "../../../../../../services/adapters/kepegawaian/homeService"
import { 
    cutiTypeList,
    signatoriesList,
    cutiDetail,
    cutiApproval
} from '../../../../../../services/adapters/kepegawaian/cutiService'


class IndexRepository {

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }

    fetchEmployeeStatus = async (query) => {
        return await apiRequest("get", masterEmployeeStatus, {
            params: query
        }, true)
    }

   fetchTypeList = async (query, cancelToken) => {
        return await apiRequest("get", cutiTypeList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchSignatoriesList = async (query, cancelToken) => {
        return await apiRequest("get", signatoriesList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", cutiDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchApproval = async (query, cancelToken) => {
        return await apiRequest("post", cutiApproval, {
            body: query
        }, true)
    }


}

export default IndexRepository